import React, { Component } from "react";
import { Loader } from "semantic-ui-react";
import InfiniteScroll from "react-infinite-scroller";
import "./index.css";

class CollectionsList extends Component {
  constructor(props) {
    super(props);
    this.loadMoreCollections = this.loadMoreCollections.bind(this);
  }

  loadMoreCollections() {
    this.props.loadMoreCollections({});
  }

  render() {
    const { data: collections = [], hasMore } = this.props.collections;

    if (collections.length === 0 && !hasMore) {
      return <h4 className="notfound-text"> No collections yet </h4>;
    }

    return (
      <InfiniteScroll
        loadMore={this.loadMoreCollections}
        hasMore={hasMore}
        loader={
          <div className="padded">
            <Loader size="large" active inline="centered" />
          </div>
        }
        {...this.props.infiniteScrollerProps}
      >
        <div className="collections-list">
          {collections.map(collection => (
            <this.props.collectionComponent
              collection={collection}
              key={collection._id}
              {...this.props.collectionProps}
            />
          ))}
        </div>
      </InfiniteScroll>
    );
  }
}

export default CollectionsList;



// WEBPACK FOOTER //
// ./src/scenes/CollectionsPage/components/CollectionsList/index.js